export enum ELocale {
  ES = "es-ES",
  EN = "en-US",
  CA = "ca",
  SW = "sw",
  SV = "sv-SE",
}
